import React from 'react';
import Api from './api';

const SpotifyApiContext = React.createContext<Api>(new Api());

export default SpotifyApiContext;
